import { render } from "./DanhSachThongBao.vue?vue&type=template&id=110d65d4&scoped=true"
import script from "./DanhSachThongBao.vue?vue&type=script&lang=js"
export * from "./DanhSachThongBao.vue?vue&type=script&lang=js"

import "./DanhSachThongBao.vue?vue&type=style&index=0&id=110d65d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-110d65d4"]])

export default __exports__